import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionLabel, GoldButton } from "@/components/ui-kit";
import { PageHero } from "@/components/blocks";
import { images, memberships } from "@/data/site";

export default function Abbonamenti() {
  return (
    <>
      <Seo title="Abbonamenti Palestra a Lusciano | Body Evolution 2.0" description="Scopri le formule di abbonamento di Body Evolution 2.0 a Lusciano: mensile, trimestrale, annuale, sala pesi, corsi, personal training, kids e family." />
      <PageHero label="Abbonamenti" title="Trova la formula più adatta al tuo percorso" image={images.weightRoom}
        text="Body Evolution 2.0 propone diverse formule di abbonamento pensate per adattarsi alle esigenze di ogni cliente: da chi vuole allenarsi in sala pesi a chi preferisce seguire corsi, fino alle soluzioni più complete e ai percorsi dedicati alla famiglia." />

      <section className="bg-sand py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal><SectionLabel>Le formule</SectionLabel></Reveal>
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {memberships.map((m, i) => (
              <Reveal key={m.title} delay={(i % 4) * 0.06}>
                <div data-testid={`membership-${i}`} className="lift group h-full bg-white border border-black/10 rounded-sm p-7 hover:border-gold flex flex-col">
                  <h3 className="font-display text-2xl font-medium text-ink-800">{m.title}</h3>
                  <p className="mt-3 text-ink-800/60 text-sm leading-relaxed flex-1">{m.text}</p>
                  <div className="mt-6 pt-4 border-t border-black/5">
                    <div className="text-xs uppercase tracking-[0.18em] text-gold font-semibold">Prezzo su richiesta</div>
                    <Link to="/contatti" className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-ink-800 group-hover:text-gold transition-colors">
                      Scopri la formula <ArrowUpRight size={16} />
                    </Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-14 text-center">
              <GoldButton to="/contatti">Richiedi il piano più adatto a te</GoldButton>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
